import * as React from "react";

import "diff2html/bundles/css/diff2html.min.css";
import {
    Diff2HtmlConfig,
    html as Diff2Html,
    parse as Diff2HtmlParse,
} from "diff2html";
import { unifiedDiff } from "difflib";

interface GhLikeDiffProps {
    previous: string | undefined;
    current: string | undefined;
    options: Diff2HtmlConfig;
    name: string;
}

class GhLikeDiff extends React.PureComponent<GhLikeDiffProps> {
    render() {
        const previousArray = (this.props.previous || "").split(/\r|\n|\r\n/);
        const currentArray = (this.props.current || "").split(/\r|\n|\r\n/);
        const uniDiff = unifiedDiff(previousArray, currentArray, {
            fromfile: this.props.name,
            tofile: this.props.name,
        });
        const diffString = `diff --git a/${this.props.name} b/${
            this.props.name
        }\n${uniDiff.join("\n")}`;
        const diff = Diff2HtmlParse(diffString, this.props.options);
        const inner = Diff2Html(diff, this.props.options);
        return <div dangerouslySetInnerHTML={{ __html: inner }} />;
    }
}

export { GhLikeDiff };
